import { useCallback, useContext, useEffect, useState } from "react"
import styles from './index.module.scss';
import ShootList from './components/shootList'
import VersionAndSkuList from './components/VersionAndSkuList'

export default function MasterShoot() {
    const [shootListId, setShootListId] = useState();
    const [shootListName, setShootListName] = useState();
    const [shootListSkuId, setShootListSkuId] = useState();
    const [shootListVersion, setShootListVersion] = useState();
    const [shootListVersionVirtual, setShootListVersionVirtual] = useState();

    useEffect(() => {
        if(sessionStorage.getItem('shootListId')) {
            setShootListId(sessionStorage.getItem('shootListId'))
            setShootListName(sessionStorage.getItem('shootListName'))
            setShootListSkuId(sessionStorage.getItem('shootListSkuId'))
            setShootListVersion(sessionStorage.getItem('shootListVersion'))
            setShootListVersionVirtual(sessionStorage.getItem('shootListVersionVirtual'))
        }
        return () => {
            if (sessionStorage.getItem('shootListId')) {
                sessionStorage.removeItem('shootListId')
                sessionStorage.removeItem('shootListName')
                sessionStorage.removeItem('shootListSkuId')
                sessionStorage.removeItem('shootListVersion')
                sessionStorage.removeItem('shootListVersionVirtual')
            }
        }
    }, [])

    const handleSkuClick = useCallback((item, version, virtual) => {
        const {id, skuId} = item
        sessionStorage.setItem('shootListId', id)
        sessionStorage.setItem('shootListName', item.skuCode || item.skuNumber)
        sessionStorage.setItem('shootListSkuId', skuId)
        sessionStorage.setItem('shootListVersion', version)
        sessionStorage.setItem('shootListVersionVirtual', virtual)
        setShootListId(id)
        setShootListName(item.skuCode || item.skuNumber)
        setShootListSkuId(skuId)
        setShootListVersion(version)
        setShootListVersionVirtual(virtual)
    }, [])

    const handleGoBack = useCallback(() => {
        setShootListId()
        setShootListName()
        setShootListSkuId()
        sessionStorage.removeItem('shootListId')
        sessionStorage.removeItem('shootListName')
        sessionStorage.removeItem('shootListSkuId')
    }, [])

    return (
        <div className={styles.masterShoot}>
        {
            shootListId ? 
            <ShootList
                shootListId={shootListId}
                shootListName={shootListName}
                shootListSkuId={shootListSkuId}
                shootListVersion={shootListVersion}
                shootListVersionVirtual={shootListVersionVirtual}
                goBack={handleGoBack}
            /> :
            // <SkuList onSkuClick={handleSkuClick} />
            <VersionAndSkuList
                version={shootListVersion}
                onSkuClick={handleSkuClick}
            />
        }
        </div>
    );
}